import React, { useContext } from 'react';
import BaseApp from '../base_app';
import { IndexData } from '../../common/index-context';
import steps from './steps';

const Index = ({ redirectPath, texts }) => {
  const {
    setForceOpenFilterDropDown, setForceOpenButton,
    openTourModal
  } = useContext(IndexData);

  const stepsFunc = steps({
    setForceOpenFilterDropDown,
    setForceOpenButton,
    openTourModal
  });

  return (
    <BaseApp
      redirectPath={ redirectPath }
      texts={ texts }
      steps={ stepsFunc }
      tourName="naming"
    />
  );
};


export default Index;
